(() => {
  'use strict';
  function initialize(root) {
    if (root.dataset.guideReady) return;
    const controls = root.querySelector('[data-guide-controls]');
    const results = [...root.querySelectorAll('[data-guide-case][data-guide-hub]')];
    if (!controls || !results.length) return;
    const current = () => ({
      useCase: controls.querySelector('input[name^="guide-case-"]:checked')?.value,
      hub: controls.querySelector('input[name^="guide-hub-"]:checked')?.value,
    });
    function update(announce) {
      const {useCase, hub} = current();
      const active = results.find(panel => panel.dataset.guideCase === useCase && panel.dataset.guideHub === hub);
      if (!active) return;
      results.forEach(panel => { panel.hidden = panel !== active; });
      const summary = root.querySelector('[data-guide-summary]');
      if (summary) {
        summary.querySelector('[data-guide-summary-title]').textContent = controls.querySelector('input[name^="guide-case-"]:checked')?.closest('label').querySelector('strong')?.textContent || active.querySelector('h3')?.textContent;
        summary.querySelector('[data-guide-summary-detail]').textContent = hub === 'have' ? 'For your existing compatible hub' : 'Starting with a compatible hub';
        summary.querySelector('[data-guide-summary-state]').textContent = announce ? 'Updated recommendation' : 'Your recommendation';
        summary.hidden = false;
      }
      if (announce) {
        const status = root.querySelector('[data-guide-status]');
        if (status) status.textContent = active.querySelector('h3')?.textContent + ' ' +
          (hub === 'have' ? 'Recommendations for your existing system.' : 'Recommendations for starting a system.');
      }
    }
    update(false);
    controls.hidden = false;
    controls.addEventListener('change', () => update(true));
    root.dataset.guideReady = 'true';
  }
  function mount(scope) {
    if (scope.matches?.('[data-yl-buying-guide]')) initialize(scope);
    scope.querySelectorAll?.('[data-yl-buying-guide]').forEach(initialize);
  }
  mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
